// Feature content creators for FeatureManager
window.createRSVPContent = function createRSVPContent() {
    return `
        <!-- RSVP Deadline at top -->
        <div class="row mb-4">
            <div class="col-md-6 col-12 date-time-clickable">
                <label class="form-label mb-2" for="rsvpDeadline">RSVP Deadline</label>
                <input type="date" class="form-control shadow-none border border-secondary" id="rsvpDeadline" name="rsvp_deadline" required>
            </div>
            <!-- RSVP Guest Count -->
            <div class="col-md-6 col-12 mt-3 mt-md-0">
                <div class="guest-count-container">
                    <label class="form-label mb-2" for="rsvpGuestCount">Expected Guest Count</label>
                    <div class="input-group">
                        <button type="button" class="btn btn-outline-light text-dark shadow-none border" id="decreaseGuestCount" tabindex="-1" title="Decrease guest count">
                            <i class="bi bi-dash"></i>
                        </button>
                        <input type="number" class="form-control text-center" id="rsvpGuestCount" name="rsvp_guest_count" min="10" max="500" value="10" step="5" readonly>
                        <button type="button" class="btn btn-outline-light text-dark shadow-none border" id="increaseGuestCount" tabindex="-1" title="Increase guest count">
                            <i class="bi bi-plus"></i>
                        </button>
                    </div>
                    <div id="rsvpGuestCount" class="form-text">$0.50 per guest. As the guest count increases, the cost will be reduced.</div>
                </div>
            </div>
        </div>

        <!-- RSVP Form Builder -->
        <div class="rsvp-form-builder">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="mb-0">RSVP Questions</h6>
                <div class="dropdown">
                    <button class="btn btn-primary btn-sm dropdown shadow-none" type="button" id="addQuestionDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-plus-lg me-1"></i>Add Question
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="addQuestionDropdown">
                        <li><a class="dropdown-item" href="#" onclick="addRSVPQuestion('text')"><i class="bi bi-type me-2"></i>Text Input</a></li>
                        <li><a class="dropdown-item" href="#" onclick="addRSVPQuestion('textarea')"><i class="bi bi-textarea-t me-2"></i>Long Text</a></li>
                        <li><a class="dropdown-item" href="#" onclick="addRSVPQuestion('single')"><i class="bi bi-record-circle me-2"></i>Single Choice</a></li>
                        <li><a class="dropdown-item" href="#" onclick="addRSVPQuestion('multiple')"><i class="bi bi-check2-square me-2"></i>Multiple Choice</a></li>
                        <li><a class="dropdown-item" href="#" onclick="addRSVPQuestion('yesno')"><i class="bi bi-toggle-on me-2"></i>Yes/No</a></li>
                        <li><a class="dropdown-item" href="#" onclick="addRSVPQuestion('rating')"><i class="bi bi-star me-2"></i>Rating</a></li>
                    </ul>
                </div>
            </div>

            <!-- Questions Container -->
            <div id="rsvpQuestionsContainer" class="questions-container">
                <!-- Default Attendance Question -->
                <div class="question-item" data-question-id="attendance">
                    <div class="question-header">
                        <div class="question-controls">
                            <button type="button" class="move-btn move-up" onclick="moveQuestion('attendance', 'up')" title="Move up">
                                <i class="bi bi-chevron-up"></i>
                            </button>
                            <button type="button" class="move-btn move-down" onclick="moveQuestion('attendance', 'down')" title="Move down">
                                <i class="bi bi-chevron-down"></i>
                            </button>
                        </div>
                        <div class="question-content flex-grow-1">
                            <div class="form-floating mb-2">
                                <input type="text" class="form-control question-title" value="Will you be joining us for the event?" readonly>
                                <label>Question Title</label>
                            </div>
                            <div class="question-type-badge">
                                <span class="badge bg-primary">Single Choice</span>
                            </div>
                        </div>
                    </div>
                    <div class="question-options">
                        <div class="option-item">
                            <div class="input-group input-group-sm">
                                <span class="input-group-text"><i class="bi bi-record-circle"></i></span>
                                <input type="text" class="form-control" value="Yes, I'll be there" readonly>
                            </div>
                        </div>
                        <div class="option-item">
                            <div class="input-group input-group-sm">
                                <span class="input-group-text"><i class="bi bi-record-circle"></i></span>
                                <input type="text" class="form-control" value="No, can't make it" readonly>
                            </div>
                        </div>
                        <div class="option-item">
                            <div class="input-group input-group-sm">
                                <span class="input-group-text"><i class="bi bi-record-circle"></i></span>
                                <input type="text" class="form-control" value="Maybe" readonly>
                            </div>
                        </div>
                    </div>
                    <div class="question-footer">
                        <span class="text-muted">Required</span>
                    </div>
                </div>
            </div>

            <!-- Form Preview Section -->
            <div class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-0">Form Preview</h6>
                    <button type="button" class="btn btn-outline-primary btn-sm shadow-none" onclick="toggleRSVPPreview()">
                        <i class="bi bi-eye me-1"></i>Preview
                    </button>
                </div>
                <div id="rsvpFormPreview" class="form-preview" style="display: none;">
                    <div class="card">
                        <div class="card-body">
                            <h6 class="card-title">RSVP Form Preview</h6>
                            <div id="rsvpPreviewContent">
                                <!-- Preview content will be generated here -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

window.createTriviaContent = function createTriviaContent() {
    return `
        <div class="row mb-3">
            <div class="col-12">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="enableTrivia" checked>
                    <label class="form-check-label" for="enableTrivia">
                        Enable Trivia Game for this event
                    </label>
                </div>
            </div>
        </div>
        <div class="form-floating mb-3">
            <input type="text" class="form-control shadow-none border border-secondary" id="triviaTitle" name="trivia_title" placeholder="Game Title" required>
            <label for="triviaTitle">Game Title</label>
        </div>
        <div class="form-floating mb-3">
            <textarea class="form-control shadow-none border border-secondary" id="triviaDescription" name="trivia_description" placeholder="Game Description" style="height: 100px;" required></textarea>
            <label for="triviaDescription">Game Description</label>
        </div>
        <div class="form-floating mb-3">
            <select class="form-select shadow-none border border-secondary" id="triviaDifficulty" name="trivia_difficulty" required>
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
            </select>
            <label for="triviaDifficulty">Difficulty Level</label>
        </div>
    `;
}

window.createGiftRegistryContent = function createGiftRegistryContent() {
    return `
        <!-- Gift Registry Enable Toggle -->
        <div class="row mb-4">
            <div class="col-12">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="enableGiftRegistry" checked>
                    <label class="form-check-label" for="enableGiftRegistry">
                        <strong>Enable Gift Registry for this event</strong>
                    </label>
                </div>
                <small class="text-muted">Allow guests to view and purchase gifts for your event</small>
            </div>
        </div>

        <!-- Gift Registry Options -->
        <div id="giftRegistryOptions">
            <!-- Registry Type Selection -->
            <div class="mb-4">
                <h6 class="mb-3">Choose Registry Type</h6>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <div class="card h-100 registry-type-card" data-type="third-party">
                            <div class="card-body text-center">
                                <i class="bi bi-link-45deg display-4 text-primary mb-3"></i>
                                <h6 class="card-title">Third-Party Registries</h6>
                                <p class="card-text text-muted">Link existing registries from Amazon, Target, Walmart, etc.</p>
                                <button type="button" class="btn btn-outline-primary btn-sm" onclick="selectRegistryType('third-party')">
                                    Select This Option
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <div class="card h-100 registry-type-card" data-type="custom">
                            <div class="card-body text-center">
                                <i class="bi bi-plus-circle display-4 text-success mb-3"></i>
                                <h6 class="card-title">Custom Gift List</h6>
                                <p class="card-text text-muted">Create your own gift list with products and links</p>
                                <button type="button" class="btn btn-outline-success btn-sm" onclick="selectRegistryType('custom')">
                                    Select This Option
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Third-Party Registries Section -->
            <div id="thirdPartySection" class="registry-section" style="display: none;">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-0">Third-Party Registry Links</h6>
                    <button type="button" class="btn btn-primary btn-sm" onclick="addThirdPartyRegistry()">
                        <i class="bi bi-plus-lg me-1"></i>Add Registry Link
                    </button>
                </div>
                
                <div id="thirdPartyRegistries" class="third-party-container">
                    <!-- Registry links will be added here -->
                </div>

                <!-- Popular Registry Templates -->
                <div class="mt-4">
                    <h6 class="mb-3">Popular Registries</h6>
                    <div class="row">
                        <div class="col-6 col-md-3 mb-2">
                            <button type="button" class="btn btn-outline-warning w-100 btn-sm" onclick="addQuickRegistry('amazon')">
                                <i class="bi bi-cart me-1"></i>Amazon
                            </button>
                        </div>
                        <div class="col-6 col-md-3 mb-2">
                            <button type="button" class="btn btn-outline-danger w-100 btn-sm" onclick="addQuickRegistry('target')">
                                <i class="bi bi-bullseye me-1"></i>Target
                            </button>
                        </div>
                        <div class="col-6 col-md-3 mb-2">
                            <button type="button" class="btn btn-outline-primary w-100 btn-sm" onclick="addQuickRegistry('walmart')">
                                <i class="bi bi-shop me-1"></i>Walmart
                            </button>
                        </div>
                        <div class="col-6 col-md-3 mb-2">
                            <button type="button" class="btn btn-outline-info w-100 btn-sm" onclick="addQuickRegistry('other')">
                                <i class="bi bi-plus me-1"></i>Other
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Custom Gift List Section -->
            <div id="customListSection" class="registry-section" style="display: none;">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-0">Custom Gift List</h6>
                    <button type="button" class="btn btn-success btn-sm" onclick="addCustomGift()">
                        <i class="bi bi-plus-lg me-1"></i>Add Gift Item
                    </button>
                </div>
                
                <div id="customGiftList" class="custom-gifts-container">
                    <!-- Custom gifts will be added here -->
                </div>
            </div>

            <!-- Registry Settings -->
            <div class="mt-4">
                <h6 class="mb-3">Registry Settings</h6>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="allowGuestContributions" checked>
                            <label class="form-check-label" for="allowGuestContributions">
                                Allow group contributions for expensive items
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="showGiftStatus" checked>
                            <label class="form-check-label" for="showGiftStatus">
                                Show gift purchase status to guests
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="enableGiftNotes">
                            <label class="form-check-label" for="enableGiftNotes">
                                Allow guests to add personal notes
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="privateRegistry">
                            <label class="form-check-label" for="privateRegistry">
                                Make registry private (invitation only)
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Registry Message -->
            <div class="mt-4">
                <div class="form-floating">
                    <textarea class="form-control" id="registryMessage" name="registry_message" placeholder="Add a personal message for your guests..." style="height: 80px;"></textarea>
                    <label for="registryMessage">Personal Message to Guests (Optional)</label>
                </div>
                <small class="text-muted">This message will be displayed at the top of your gift registry</small>
            </div>
        </div>
    `;
}
